import type { ImageType } from '@vizit/api';
import * as React from 'react';
import type { CollectionSortOption } from './collection-grid-provider.state';

interface CollectionGridContextValue {
  /**
   * The ID of the portfolio to fetch collections for
   */
  workspaceId?: string;
  /**
   * The ID of the organization
   */
  organizationId?: string;
  /**
   * Number of items to fetch per page
   */
  limit: number;
  productCategoryId?: string | null;
  productCategoryName?: string;
  imageType?: ImageType | null;
  searchTerm?: string;
  sortOption: CollectionSortOption;
  onFilterProductCategory: (productCategoryId: string | null, productCategoryName: string) => void;
  onFilterImageType: (imageType: ImageType | null) => void;
  onSearchTermChange: (searchTerm: string) => void;
  onSortOptionChange: (sortOption: CollectionSortOption) => void;
}

const CollectionGridContext = React.createContext<CollectionGridContextValue | undefined>(undefined);

export { CollectionGridContext };
export type { CollectionGridContextValue };
